var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",attrs:{"version":"1.0.0"}},[(_vm.authChecked)?_c('router-view'):_c('div',{staticClass:"loading-state"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }